import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateTrackingReport } from '@/features/projects/kpi-tracking-entry/api/update-tracking-report';
import { invalidateTrackingReportQueries } from '@/features/projects/kpi-tracking-entry/hooks/use-tracking-reports';

type UpdateTrackingReportMutationProps = {
  projectId: number;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
};

export const useUpdateTrackingReportMutation = ({
  projectId,
  onSuccess,
  onError,
}: UpdateTrackingReportMutationProps) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateTrackingReport,
    onSuccess: () => {
      invalidateTrackingReportQueries(queryClient, projectId);
      onSuccess?.();
    },
    onError: (error: Error) => {
      onError?.(error);
    },
  });
};
